/*
 * The wrapping ol and list li is baked into
 * Algolia widget. Adjust the classes on those in
 * ElementsSearchResults.js
 * See: https://www.algolia.com/doc/api-reference/widgets/infinite-hits/js/#widget-param-cssclasses
 */
// @DEV: same as fallback in item/generators/default.twig

const instance = document.querySelector('[data-module="AlgoliaGenerators"]');
const imgixTransform = instance.dataset.transform;
export const generatorHitTpl = (data) => {
  return `
    <a 
      href="${data.url}"
      data-modal="${data.multipleSpecSheets}" 
      data-module="GeneratorCard"
      class="flex flex-row h-full overflow-hidden transition transform bg-white md:flex-col group">
      ${data.hasImage ? `<figure class="flex-shrink-0 w-24 pr-2 md:w-full md:pb-0 mdd:pt-4 sm:pr-4 md:pr-0">
          <img src="${data.imgixUrl}${imgixTransform}" alt="Image of ${data.title}" class="mx-auto max-w-full" />
      </figure>` : ''}
      <div class="h-full pt-4 pb-8 pr-4 md:px-4 lg:px-6 smd:pb-6">
          <h3 class="text-xl leading-normal text-gray-900 font-bold mdd:group-hover:underline">
            ${data.title}
          </h3>
          <ul class="mt-px text-base leading-normal text-gray-700 smd:leading-snug">
              <li><span class="font-semibold">Brand:</span> ${data['Brand'].join(", ")}</li>
              <li><span class="font-semibold">Engine:</span> ${data['Engine Manufacturer'].join(", ")}</li>
              <li><span class="font-semibold">Fuel:</span> ${data['Fuel Type'].join(", ")}</li>
          </ul>

          <button class="text-button text-button--small">
          View Details
          </button>

      </div>
    </a>
  `;
};
